import React from 'react'
import { localizer } from '../../Translator.js';

import { Grid, Container } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';

import { PostalAddressList } from './sections/PostalAddressList.js';

import ScreenHeading from '../common/ScreenHeading.js';

import UserCli from '../../sdk/UserCli.js'

export class PostalAddressLayout extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Postal address list to be filled by API
      postalAddresses: [],

      // Postal address id that user logged has selected by default
      defaultAddress: ""
    }
  }

  /* Initilizating postal address list and getting default postal address to be highlighted */
  componentDidMount() {
    UserCli.GetSenderAddress().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ defaultAddress: response })
      }
    })
    
    UserCli.GetAddresses().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ postalAddresses: response })
      }
    })
  }
 
  /* Actions done in child component PostalAddress are returned here to be sending to API  */
  handlePostalAddress = (postalAddress, option) => {

    switch (option.toUpperCase()) {
      case "POST":
        UserCli.StoreAddress(postalAddress).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
          } else {
            postalAddress.id = response
            this.setState({ postalAddresses: [postalAddress, ...this.state.postalAddresses] })
          }
        })
        break;
      case "PUT":
        UserCli.StoreAddress(postalAddress).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
          } else {           
            let postalAddressesUpdated = this.state.postalAddresses.filter(pa => pa.id !== postalAddress.id)
            this.setState({ postalAddresses: postalAddressesUpdated })
            this.setState({ postalAddresses: [...postalAddressesUpdated, postalAddress] })
          }
        })
        
        break;
      case "DELETE":
        UserCli.RemoveAddress(postalAddress.id).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
          } else {
            var paFiltered = this.state.postalAddresses.filter(pa => pa.id !== postalAddress.id)
            this.setState({ postalAddresses: paFiltered })
          }
        })
        break;
      case "SETASDEFAULT":
        UserCli.SetDefaultSender(postalAddress.id).then(response => {
          if (response !== null && response.toString().startsWith("[ERR")) {
            this.setState({ postalAddressError: response.substring(response.indexOf(' ')) })
          } else {
            this.setState({ defaultAddress: postalAddress.id })
          }
        })
        break;
      case "SELECTADDRESS":
        if (this.props.selectPostalAddress) this.props.selectPostalAddress(postalAddress)
        break
      default:
        break;
    }
  }

  render() {
    return (
      <React.Fragment>
        
        <Container>
          {/* <GridHeaderComponent container direction="row">
            <Grid item md={12}>
              <Typography className="typography-generic header-title"><i className="fa-solid fa-address-card font-size-30"></i> {localizer.PostalAddressTitle}</Typography>
            </Grid>
          </GridHeaderComponent> */}

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-address-card icon-button-header mr-20 ml-20"></i>} title={localizer.PostalAddressTitle} />

          <Grid container direction="row" justify="center" alignItems="center" className="container-generic">
            <Typography className="typography-generic">{localizer.PostalAddressDescription}</Typography>

            <PostalAddressList postalAddresses={this.state.postalAddresses} defaultAddress={this.state.defaultAddress} handlePostalAddress={this.handlePostalAddress}></PostalAddressList>
          </Grid>
        </Container>

      </React.Fragment>
    )
  }
}

export default PostalAddressLayout


// WEBPACK FOOTER //
// ./src/components/postal-address/PostalAddressLayout.js